import SettingsService from "./SettingsService";

const RoomAvailabilityService = {

  addFromPriceAndAvailableAmountToSizeTypes: (rooms, sizeTypeBaseline) => {
    // A group can contain both indoor and outdoor container types, so
    // availability/pricing is tracked separately per orientation instead of
    // being collapsed into a single set of fields (which used to make one
    // orientation overwrite the other).
    const createOrientationStats = () => ({
      fromPrice: 0,
      availableAmount: 0,
      levelAmount: 0,
      levelPrice: [],
    });

    const updatedSizeTypes = sizeTypeBaseline.map(sizeType => ({
      ...sizeType,
      // isIndoor is left untouched here: it is only the configured fallback,
      // used when a size type is sold out in both orientations.
      indoor: createOrientationStats(),
      outdoor: createOrientationStats(),
    }));

    rooms.forEach(room => {
      // if the daily price is enabled, it should use that instead of the monthly price
    
      const useDailyPrice = SettingsService.getUseDailyRates();

      const roomSizeType = room.ItemSizeType.Name;
      const roomPrice = useDailyPrice ? room.SelfStoreDayPrice : room.SelfStoreMonthPrice;
      const levelIndex = room.level;

      updatedSizeTypes.forEach(sizeType => {
        if (!sizeType.sizeTypes.includes(roomSizeType)) return;

        const stats = room.IsIndoor ? sizeType.indoor : sizeType.outdoor;

        stats.levelAmount = Math.max(stats.levelAmount, levelIndex + 1);

        if (stats.fromPrice === 0 || roomPrice < stats.fromPrice) {
          stats.fromPrice = roomPrice;
          stats.currency = room.SelfStoreMonthPriceUniCurrency;
        }
        stats.availableAmount += 1;
        stats.sizeInSquareMeters = room.SelfStoreArea;
        stats.width = room.Width;
        stats.height = room.Height;
        stats.length = room.Length;
        if (
          (stats.levelPrice[levelIndex] == null ||
            roomPrice < stats.levelPrice[levelIndex]) &&
          roomPrice > 0
        ) {
          stats.levelPrice[levelIndex] = roomPrice;
        }
      });
    });

    return updatedSizeTypes;
  },

  mapContainerToRoom: container => ({
    Id: container.id,
    Prefix: container.prefix,
    Number: container.number,
    ItemSizeType: {
      Name: container.itemSizeType.name,
      Description: container.itemSizeType.description,
    },
    SelfStoreMonthPrice: container.selfStoreMonthPrice,
    SelfStoreMonthPriceUniCurrency: container.selfStoreMonthPriceUniCurrency,
    SelfStoreDayPrice: container.selfStoreDayPrice,
    Width: container.width,
    Height: container.height,
    Length: container.length,
    SelfStoreArea: container.selfStoreArea,
    DateFrom: container.dateFrom,
    // selfStorageLocation: 0 = indoor, 1 = outdoor
    IsIndoor: container.selfStorageLocation === 0,
    level: container.selfStoreFloor,
    sizeType: container.itemSizeType.name,
  }),

  // Fetch the currently-available rooms for a location by its order number. The backend
  // (GetFreeSelfStorageContainers) already returns only available, deduplicated containers
  fetchAvailableRoomsByLocationId: async orderNumber => {
    const response = await fetch(
      `${process.env.REACT_APP_CONSUMER_API_URL}/api/CheckoutApi/GetFreeSelfStorageContainers?orderNumber=${orderNumber}`
    );

    if (!response.ok) {
      throw new Error('Network response was not ok');
    }

    const data = await response.json();
    if (!data || !Array.isArray(data.containers)) return [];

    return data.containers.map(RoomAvailabilityService.mapContainerToRoom);
  },
};

export default RoomAvailabilityService;
